var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-signup-tabs',{attrs:{"starting-tab":1,"line":_vm.line}},[_c('p',{staticClass:"title has-text-centered"},[_vm._v("New to tinythoughts? Sign up!")])])}
var staticRenderFns = []

export { render, staticRenderFns }